import { CommonModule } from '@angular/common';
import {Component, ChangeDetectionStrategy, Inject} from '@angular/core';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-tour-filter-help',
  templateUrl: './tour-filter-help.component.html',
  styleUrls: ['./tour-filter-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class TourFilterHelpComponent {
  messages: any = {};

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig) {
    this.messages = this.hotelToursPageConfig.translates.tourFilterHelp;
  }
}
